import HttpService from '@/services/http/http.service';
import {
    UsersViewModel,
    RolesViewModel,
    PermissionsViewModel,
    FindUserRequest,
    UserQuickSearchRequest,
    UserDetailsRequest,
    UserDetailsViewModel,
    UserUpdateUserRealmsRequest,
    UserUpdateRolesRequest,
    UserUpdatePermissionsRequest,
    UpdateAccountAccessRequest,
    UpdateUserRequest,
    UpdateUserPasswordRequest,
    RealmlistsViewModel,
    GenericViewModel,
    UpdateIngameAccountPasswordRequest,
    CoreFilesViewModel,
    UpdateAllowableCoreFilesRequest
} from '@/types/apiServerContract';

const API_PATH = 'admin/';

export class AdminApi {
    public static async GetAdmins(): Promise<UsersViewModel> {
        return HttpService.Get<UsersViewModel>(API_PATH + 'GetAdmins');
    }

    public static async GetRealms(): Promise<RealmlistsViewModel> {
        return HttpService.Get<RealmlistsViewModel>(API_PATH + 'GetRealms', undefined, undefined, true);
    }

    public static async GetRoles(): Promise<RolesViewModel> {
        return HttpService.Get<RolesViewModel>(API_PATH + 'GetRoles');
    }

    public static async GetPermissions(): Promise<PermissionsViewModel> {
        return HttpService.Get<PermissionsViewModel>(API_PATH + 'GetPermissions');
    }

    public static async FindUser(request: FindUserRequest): Promise<UsersViewModel> {
        return HttpService.Post<UsersViewModel>(API_PATH + 'FindUser', request);
    }

    public static async QuickSearch(request: UserQuickSearchRequest): Promise<UsersViewModel> {
        return HttpService.Post<UsersViewModel>(API_PATH + 'QuickSearch', request);
    }

    public static async GetUserDetails(request: UserDetailsRequest): Promise<UserDetailsViewModel> {
        return HttpService.Post<UserDetailsViewModel>(API_PATH + 'GetUserDetails', request);
    }

    public static async UpdateUserRealms(request: UserUpdateUserRealmsRequest): Promise<GenericViewModel<boolean>> {
        return HttpService.Post<GenericViewModel<boolean>>(API_PATH + 'UpdateUserRealms', request);
    }

    public static async UpdateUserRoles(request: UserUpdateRolesRequest): Promise<GenericViewModel<boolean>> {
        return HttpService.Post<GenericViewModel<boolean>>(API_PATH + 'UpdateUserRoles', request);
    }

    public static async UpdateUserPermissions(request: UserUpdatePermissionsRequest): Promise<GenericViewModel<boolean>> {
        return HttpService.Post<GenericViewModel<boolean>>(API_PATH + 'UpdateUserPermission', request);
    }

    public static async UpdateAccountAccess(request: UpdateAccountAccessRequest): Promise<GenericViewModel<boolean>> {
        return HttpService.Post<GenericViewModel<boolean>>(API_PATH + 'UpdateAccountAccess', request);
    }

    public static async UpdateWebsiteProfile(request: UpdateUserRequest): Promise<GenericViewModel<boolean>> {
        return HttpService.Post<GenericViewModel<boolean>>(API_PATH + 'UpdateWebsiteProfile', request);
    }

    public static async UpdateWebsitePassword(request: UpdateUserPasswordRequest): Promise<GenericViewModel<boolean>> {
        return HttpService.Post<GenericViewModel<boolean>>(API_PATH + 'UpdateWebsitePassword', request);
    }

    public static async UpdateIngameAccountPassword(request: UpdateIngameAccountPasswordRequest): Promise<GenericViewModel<boolean>> {
        return HttpService.Post<GenericViewModel<boolean>>(API_PATH + 'UpdateIngameAccountPassword', request);
    }

    public static async GetCoreFiles(): Promise<CoreFilesViewModel> {
        return HttpService.Get<CoreFilesViewModel>(API_PATH + 'GetCoreFiles');
    }

    public static async UpdateAllowedCoreFilesForRealm(request: UpdateAllowableCoreFilesRequest): Promise<GenericViewModel<boolean>> {
        return HttpService.Post<GenericViewModel<boolean>>(API_PATH + 'UpdateAllowedCoreFilesForRealm', request);
    }
}
